import { ReactElement } from "react";
import {
	Anchor,
	FormattedText
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { reloadCurrentPage } from "client_legacy/ndaw/navigator";

export const PermissionChangeErrorMessage = (): ReactElement => {
	return (
		<FormattedText
			text={localize("_YourPermissionsHaveChangedClickHereToRefreshThePage")}
			thingsToWrap={[{
				blockId: "Here",
				wrap: (children) => (
					<Anchor
						onClick={reloadCurrentPage}
					>
						{children}
					</Anchor>
				)
			}]}
		/>
	);
};
PermissionChangeErrorMessage.DisplayName = "PermissionChangeErrorMessage";